import { Button, styled, Theme } from '@material-ui/core';
import { StyledDialog } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
const { PRIMARY_BUTTON_BORDER, DARK_BACKGROUND, LIGHT_BACKGROUND } = COLORS;
import { CustomTypography } from 'shared/elements/CustomTypography';

export const NewCont = styled('div')(({ theme, jobs }: { theme: Theme; jobs?: boolean }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
  gap: 10,
  backgroundColor: jobs ? (theme.palette.type === 'dark' ? DARK_BACKGROUND : LIGHT_BACKGROUND) : 'transparent',
}));

export const FilterButton = styled(Button)(({ theme }) => ({
  borderColor: PRIMARY_BUTTON_BORDER,
  backgroundColor: 'transparent',
  padding: 10,
  marginRight: 15,
}));

export const PreferenceText = styled(CustomTypography)(({ theme }) => ({
  alignSelf: 'center',
  [theme.breakpoints.down('xs')]: {
    textAlign: 'center',
  },
}));

export const CustomDialog = styled(StyledDialog)({
  padding: 0,
  '&.paper': {
    minWidth: '100%',
    minHeight: '100%',
  },
  '& .MuiDialog-paperWidthSm': {},
});
export const MobileFilterCont = styled('div')(({ theme }) => ({
  padding: 10,
}));
